// Auto-extracted from SellerProducts.jsx
import { useState, useEffect, useMemo } from "react";
import { C } from "../../lib/theme";
import { Card } from "../../components/Card";
import { Btn } from "../../components/Btn";
import { Eyebrow } from "../../components/Eyebrow";
import { Icon } from "../../components/Icon";
import { Skeleton } from "../../components/Skeleton";
import { EmptyState } from "../../components/EmptyState";
import { supabase } from "../../lib/supabase";
import { fmtK } from "../../lib/money";
import { gradientForId } from "../../lib/gradients";
import { resolveImage } from "../../lib/images";
import { useCategories } from "../../hooks/useCategories";
import { STATUS_TABS, PRESET_VARIANT_TYPES, DELIVERY_METHODS, MAX_PHOTOS } from "./constants";

export function FieldLabel({ children }) {
  return (
    <div
      style={{
        fontSize: 10.5,
        fontWeight: 800,
        color: C.muted,
        textTransform: "uppercase",
        letterSpacing: 1,
      }}
    >
      {children}
    </div>
  );
}

export function Field({ label, children, style }) {
  return (
    <label style={{ display: "block", ...style }}>
      <div style={{ marginBottom: 6 }}>
        <FieldLabel>{label}</FieldLabel>
      </div>
      {children}
    </label>
  );
}

export function Section({ title, hint, children }) {
  return (
    <div>
      <div style={{ fontSize: 13, fontWeight: 900, color: C.charcoal, letterSpacing: "-0.2px" }}>{title}</div>
      {hint && <div style={{ fontSize: 11, color: C.muted, marginTop: 2, marginBottom: 10 }}>{hint}</div>}
      {!hint && <div style={{ height: 10 }} />}
      {children}
    </div>
  );
}

